import React from 'react';
import {
  Checkbox,
  Column,
  Flex,
  IColumnProps,
} from '@grubhubprod/gh-cookbook-react';
import { useDataTableSelectionContext } from 'src/components/DataTable/components/DataTableSelectionProvider/hooks/useDataTableSelectionContext';

export type DataTableSelectableCellProps = Pick<
  IColumnProps,
  'phone' | 'tablet' | 'desktop'
> & {
  id: string;
};

export const DataTableSelectableCell: React.FC<DataTableSelectableCellProps> =
  ({ id, phone = 1, tablet, desktop }) => {
    const { isSelected, toggleSelection, isLoading } =
      useDataTableSelectionContext();

    const checked = isSelected(id);

    const handleChange = (): void => {
      if (!isLoading) {
        toggleSelection(id);
      }
    };

    return (
      <Column phone={phone} tablet={tablet} desktop={desktop} gutter={12}>
        <Flex
          className="cancelMarginCheckboxLabel"
          alignItems="center"
          width="100%"
          height="100%"
        >
          <Checkbox
            checked={checked}
            onChange={handleChange}
            disabled={isLoading}
          />
        </Flex>
      </Column>
    );
  };
